import styled from "styled-components";

export const DetailsContainer = styled.div`
  margin-top: 2rem;
  padding: 1.5rem 1.5rem;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);
`;

export const BoxDiv = styled.div`
  background-color: #f0f0f0;
  padding: 1.25rem;
  border-radius: 0.625rem;
`;

export const FlexDiv = styled.div`
  display: flex;
  font-size: 0.875rem;
  padding: 10px 0.625rem;
  align-items: flex-start;
`;

export const FlexChild = styled.span`
  width: 22%;
  margin: 0 0.625rem;
  font-weight: 600;
  flex-shrink: 0;
`;

export const FlexChildTwo = styled.span`
  width: 58%;
  font-weight: normal;
  word-break: break-word;
`;

export const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 280px;
  border-radius: 8px;
  margin-top: 0.5rem;
  object-fit: contain;
`;

export const DetailsActionsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 1.5rem;
  padding: 0 1.5rem 1.5rem;

  .trigger-notification-btn {
    white-space: nowrap;
    width: auto !important;
    min-width: 11.75rem;
    padding: 0 1.25rem;
  }
`;
